export { RESET, ERROR, PGE_MGR_EDIT_PAGE } from '@/main/store/actionTypes';

export const START_LOADING = <const>'startLoading';
export const END_LOADING = <const>'endLoading';
export const START_LOADING_V2 = <const> 'startLoadingV2';
export const END_LOADING_V2 = <const>'endLoadingV2';
export const ROW_DETAIL_LOADING = <const>'ROW_DETAIL_LOADING';
export const RESET_FILTER = <const>'RESET_FILTER';
export const RECOMPUTE_HASH = <const>'RECOMPUTE_HASH';

export const CHANGE_OPERATIONS = <const>'changeOpreations';

export const SET_CANCEL_TOKEN = 'setCancelToken';

export const UPDATE_BASIC_FILTER = <const>'UPDATE_BASIC_FILTER';
export const UPDATE_BASIC_TABLE_SCHEMA = <const>'UPDATE_BASIC_TABLE_SCHEMA';
export const UPDATE_BASIC_TABLE_DATA = <const>'UPDATE_BASIC_TABLE_DATA';
export const UPDATE_BASIC_TABLE_SCHEMA_DATA = <const>'UPDATE_BASIC_TABLE_SCHEMA_DATA';
export const UPDATE_BASIC_EDIT = <const>'updateBasicEdit';
export const UPDATE_EDIT_HASH = <const>'updateEditHash';

export const FILTER = <const>'FILTER';
export const TABLE_SCHEMA = <const>'TABLE_SCHEMA';
export const TABLE_DATA = <const>'TABLE_DATA';
export const TABLE_DATA_EXPORT = <const>'TABLE_DATA_EXPORT';
export const TABLE_SCHEMA_DATA = <const>'TABLE_SCHEMA_DATA';
export const TABLE_DATA_DELETE = <const>'TABLE_DATA_DELETE';
export const DEFAULT = <const>'DEFAULT';
export const ENTITY = <const>'ENTITY';
export const CREATE = <const>'CREATE';
export const UPDATE = <const>'UPDATE';
export const DELETE = <const>'DELETE';
export const LIST_RESET = <const>'LIST_RESET';
export const EDIT_RESET = <const>'EDIT_RESET';
export const ROW_DETAIL = <const>'ROW_DETAIL';
export const SAVE_SORT = <const>'SAVE_SORT';
export const COLUMN_VISIBLE = <const>'setColumnVisible';

export const STORE_EDIT = <const>'Edit';
export const STORE_LIST = <const>'List';
export const STORE_SELECT_LIST = <const>'SelectList';
export const STORE_FILTER = <const>'Filter';
export const STORE_TABLE = <const>'Table';
export const SET_PROPS = <const>'SET_PROPS';

/** Appends {@link STORE_EDIT} to `prefix`. */
export function editName(prefix: string) { return `${prefix}${STORE_EDIT}`; }

/** Appends {@link STORE_LIST} to `prefix`. */
export function listName(prefix: string) { return `${prefix}${STORE_LIST}`; }

/** Appends {@link STORE_SELECT_LIST} to `prefix`. */
export function selectListName(prefix: string) { return `${prefix}${STORE_SELECT_LIST}`; }
